import React from "react";
import {
  Box,
  Typography,
  Card,
  Container,
  Grid,
} from "@mui/material";

const Psychology: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", py: 8 }}>
      <Container maxWidth="lg">

        {/* ✅ GRID START */}
        <Grid container spacing={8} alignItems="center">

          {/* LEFT IMAGE (6) */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://dprstorage.b-cdn.net/RW/leadgen/priyankalinkedin.jfif"
              alt="bridge"
              sx={{
                width: "100%",
                borderRadius: 3,
              }}
            />
          </Grid>

          {/* RIGHT CONTENT (6) */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              sx={{
                color: "#000",
                textAlign: "start",
                background:
                  "linear-gradient(135deg, rgba(15,99,165,0.1), rgba(255,255,255,0.4))",
              }}
            >
              This Is Not Just Sales Training.
            </Typography>

            <Typography
              variant="h3"
              sx={{ color: "#0f63a5", textAlign: "start" }}
            >
              This Is Sales Psychology.
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#555",
                mb: 3,
                textAlign: "start",
                mt: 2,
              }}
            >
              Most people are taught to chase clients. Cold calls. Follow ups.
              Endless persuasion.
            </Typography>

            {/* CARDS */}
            {[
              "That's not how high Value deals are closed.",
              "At the top level, clients don't get convinced they decide.",
              "This system is built from real world, high stakes conversations, where positioning, authority, and timing close deals not pressure.",
            ].map((text, index) => (
              <Card
                key={index}
                sx={{
                  position: "relative",
                  mb: 3,
                  borderRadius: "20px",
                  padding: "1px",
                  background:
                    "linear-gradient(135deg, #0f63a5, #3aa0ff, #ffffff)",
                  boxShadow: "0 10px 40px rgba(15, 99, 165, 0.25)",

                  "& .inner": {
                    borderRadius: "19px",
                    background: "rgba(255, 255, 255, 0.65)",
                    backdropFilter: "blur(18px)",
                    padding: "20px",
                    transition: "all 0.4s ease",
                  },

                  "&:hover .inner": {
                    background: "rgba(255, 255, 255, 0.8)",
                    transform: "translateY(-6px) scale(1.01)",
                    boxShadow: "0 20px 60px rgba(15, 99, 165, 0.35)",
                  },

                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-75%",
                    width: "50%",
                    height: "100%",
                    background:
                      "linear-gradient(120deg, transparent, rgba(255,255,255,0.6), transparent)",
                    transform: "skewX(-20deg)",
                    transition: "0.6s",
                  },

                  "&:hover::before": {
                    left: "130%",
                  },
                }}
              >
                <Box className="inner">
                  {/* NUMBER */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 12,
                      right: 16,
                      fontSize: "14px",
                      fontWeight: 700,
                      color: "#000",
                      opacity: 0.6,
                      fontFamily: "playfair display, serif",
                    }}
                  >
                    0{index + 1}
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "#0f63a5",
                      fontWeight: 600,
                      fontSize: "12px",
                      letterSpacing: "0.3px",
                      textAlign: "start",
                    }}
                  >
                    {text}
                  </Typography>
                </Box>
              </Card>
            ))}
          </Grid>
        </Grid>
        {/* ✅ GRID END */}

      </Container>
    </Box>
  );
};

export default Psychology;